import { OrganizationDetailFragment, SingleDirectorUserFragment } from '../generated/graphql';

type Company = {
  company_id: string;
  name: string;
};

class IntercomService {
  private getIntercom: () => any;
  private appId: string;
  private isBooted: boolean;

  constructor(getIntercom: () => any, appId: string) {
    this.getIntercom = getIntercom;
    this.appId = appId;
    this.isBooted = false;
  }

  public identify = (user: SingleDirectorUserFragment, organizations: Array<OrganizationDetailFragment>) => {
    this.bootOrUpdate({
      app_id: this.appId,
      user_id: user.id,
      name: user.name,
      email: user.email,
      companies: this.getCompanies(organizations),
      Director: true, // intercom custom field: used for separating user segment
    });
  };

  public anonymize = () => {
    this.bootOrUpdate({
      app_id: this.appId,
    });
  };

  private bootOrUpdate = (...args: any[]) => {
    try {
      this.getIntercom()(this.isBooted ? 'update' : 'boot', ...args);
      this.isBooted = true;
    } catch {
      this.isBooted = false;
    }
  };

  public openNewMessage = (defaultBody?: string) => {
    this.getIntercom()('showNewMessage', defaultBody);
  };

  private getCompanies = (organizations: Array<OrganizationDetailFragment>): Company[] => {
    return organizations.map((organization) => ({
      company_id: organization.id,
      name: organization.name,
      business_region: organization.businessRegion.idBusinessRegion,
    }));
  };
}

export default IntercomService;
